
import { useState } from "react";
import {
  NavigationMenu,
  NavigationMenuLink,
  NavigationMenuList,
  navigationMenuTriggerStyle
} from "@/components/ui/navigation-menu";
import { cn } from "@/lib/utils";
import RolesManagement from "../components/settings/RolesManagement";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

export default function Settings() {
  const [activeTab, setActiveTab] = useState("general");
  
  // We'll still need to check if user is admin to show the Roles tab
  const { data: userRoles, isLoading: isCheckingRole } = useQuery({
    queryKey: ['userRoles'],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error('No authenticated user');
      
      const { data, error } = await supabase
        .from('user_roles')
        .select('role')
        .eq('user_id', user.id);
      
      if (error) throw error;
      return data?.map(r => r.role) || [];
    }
  });

  const isAdmin = userRoles?.some(role => ['admin', 'owner'].includes(role));

  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-6">Settings</h1>

      <NavigationMenu className="mb-6">
        <NavigationMenuList>
          <NavigationMenuItem>
            <NavigationMenuLink
              className={cn(
                navigationMenuTriggerStyle(),
                activeTab === "general" && "bg-accent"
              )}
              onClick={() => setActiveTab("general")}
            >
              General
            </NavigationMenuLink>
          </NavigationMenuItem>
          {isAdmin && (
            <NavigationMenuItem>
              <NavigationMenuLink
                className={cn(
                  navigationMenuTriggerStyle(),
                  activeTab === "roles" && "bg-accent"
                )}
                onClick={() => setActiveTab("roles")}
              >
                Roles & Permissions
              </NavigationMenuLink>
            </NavigationMenuItem>
          )}
        </NavigationMenuList>
      </NavigationMenu>

      {activeTab === "general" && (
        <div className="space-y-4">
          <h2 className="text-lg font-medium">General Settings</h2>
          <p className="text-muted-foreground">
            General settings will be implemented here.
          </p>
        </div>
      )}

      {activeTab === "roles" && isAdmin && <RolesManagement />}
    </div>
  );
}

interface NavigationMenuItemProps {
  children: React.ReactNode;
}

function NavigationMenuItem({ children }: NavigationMenuItemProps) {
  return (
    <li>{children}</li>
  );
}
